const faqs = [
  {
    q: '大师兄影视需要注册才能观看吗？',
    a: '完全不需要。大师兄影视坚持免费开放理念，无需注册登录即可直接观看所有影视内容。我们相信好的内容不应该被门槛阻挡，打开网站就能畅快观影。',
  },
  {
    q: '影片画质如何？播放会卡顿吗？',
    a: '全站默认提供1080P高清画质，部分热门影片支持4K超清。我们采用自适应码率技术，根据您的网络状况自动调整清晰度，确保流畅不卡顿的观影体验。',
  },
  {
    q: '更新速度怎么样？新片多久上线？',
    a: '我们的内容团队24小时轮班更新，院线新片通常在下映后48小时内上线，热播剧集每日同步更新。综艺节目播出当晚即可观看回放，确保你永远快人一步。',
  },
  {
    q: '支持哪些设备观看？',
    a: '大师兄影视完美适配电脑、平板和手机端。支持 Chrome、Safari、Edge 等主流浏览器。手机端还支持投屏功能，可以将影片投射到电视大屏幕上享受家庭影院体验。',
  },
  {
    q: '遇到播放问题或内容建议怎么反馈？',
    a: '你可以通过页面底部的联系方式向我们反馈。我们非常重视每一位观众的意见，常见问题通常在24小时内得到响应。欢迎随时分享你的观影体验和内容建议。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            关于大师兄影视，你可能想了解的都在这里
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}